import Box from "@mui/material/Box";
import {
  gridFilteredSortedRowIdsSelector,
  useGridApiContext,
} from "@mui/x-data-grid";
import { useSelector } from "react-redux";

import _ from "lodash";

export function CompareSalesDataTableFooter(props) {
  const apiRef = useGridApiContext();
  const visableColumns = apiRef.current.getVisibleColumns();
  const filteredId = gridFilteredSortedRowIdsSelector(apiRef);
  const selectedSource = useSelector((state) => state.dataTable.selectedSource);
  const { rowsdata } = props;
  const filtered = _.filter(rowsdata, (rowdata) =>
    _.includes(filteredId, rowdata.index)
  );

  if (filtered.length <= 0) return;

  function Item(props) {
    const { sx, justifyContent = "flex-end", ...other } = props;
    return (
      <Box
        display="flex"
        sx={{
          p: 1,
          m: 1,
          bgcolor: (theme) => (other.children ? "grey.100" : ""),
          border: other.children ? "1px solid" : "",
          borderColor: (theme) => (other.children ? "grey.800" : ""),
          borderRadius: 2,
          fontSize: "0.875rem",
          fontWeight: "700",
          justifyContent,
          ...sx,
          fontColor: "red",
        }}
        {...other}
      />
    );
  }
  const sumOfQty = _.sumBy(filtered, (r) => Number(r.qty1));
  const sumOfAmount = _.sumBy(filtered, (r) => Number(r.amount1));
  const sumOfCompareQty = _.sumBy(filtered, (r) => Number(r.qty2));
  const sumOfCompareAmount = _.sumBy(filtered, (r) => Number(r.amount2));

  let sumOfTotalQtyVariance =
    ((sumOfQty - sumOfCompareQty) / sumOfCompareQty) * 100;

  if (_.isNaN(sumOfTotalQtyVariance) || !_.isFinite(sumOfTotalQtyVariance)) {
    sumOfTotalQtyVariance = 0;
  }

  let sumOfTotalAmountVariance =
    ((sumOfAmount - sumOfCompareAmount) / sumOfCompareAmount) * 100;

  if (
    _.isNaN(sumOfTotalAmountVariance) ||
    !_.isFinite(sumOfTotalAmountVariance)
  ) {
    sumOfTotalAmountVariance = 0;
  }
  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          bgcolor: "background.paper",
          borderRadius: 1,
        }}
      >
        {_.map(visableColumns, (visableColumn) => {
          let value = "";
          let color = "";
          switch (visableColumn.field) {
            case "amount1":
              value = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "HKD",
              }).format(sumOfAmount);
              break;
            case "qty1":
              value = new Intl.NumberFormat().format(sumOfQty);
              break;
            case "amount2":
              value = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "HKD",
              }).format(sumOfCompareAmount);
              break;
            case "qty2":
              value = new Intl.NumberFormat().format(sumOfCompareQty);
              break;
            case "variance_qty":
              color = sumOfTotalQtyVariance >= 0 ? "green" : "red";
              value = `${new Intl.NumberFormat("en", {
                minimumFractionDigits: 1,
              }).format(_.round(sumOfTotalQtyVariance, 1))}%`;
              break;
            case "variance_amount":
              color = sumOfTotalAmountVariance >= 0 ? "green" : "red";
              value = `${new Intl.NumberFormat("en", {
                minimumFractionDigits: 1,
              }).format(_.round(sumOfTotalAmountVariance, 1))}%`;
              break;
            default:
              break;
          }
          return (
            <Item
              color={color}
              key={visableColumn.field}
              width={visableColumn.computedWidth}
            >
              {value}
            </Item>
          );
        })}
      </Box>
    </>
  );
}
